<template>
<section
  v-loading="loadStatus"
  element-loading-background="rgba(0, 0, 0, 0)"
  class="wrapper"
>
  <router-view class="wrapper" />
</section>
</template>

<script>
import * as EventKeyMap from './EventKeys'

import {getRouteByModuleIds} from './router/routes'

import Login from './views/Profile/Login'
import BaseStore from './components/BaseStore'

export default {
  name: 'App',
  extends: BaseStore,
  methods: {
    onRedirect (token) {
      let route = this.$route
      let currentRouteName = route.name

      // if (token) {
      //   this.requestProfile(token, route.query.to)
      // } else if (currentRouteName !== Login.name) {
      //   this.redirectToLogin()
      // }

      if (token) {
        this.requestProfile(token, route.query.to)
      } else if (process.env.AUTH_LOGIN_URL) {
        location.replace(process.env.AUTH_LOGIN_URL.replace('{{DIRECT_URI}}', encodeURIComponent(`${location.origin}/static/redirect.html`)))
      } else if (currentRouteName !== Login.name) {
        this.redirectToLogin()
      }
    },
    redirectToLogin () {
      location.replace(`${process.env.BASE_WEB_PATH}login`)
    },
    requestProfile (token, to) {
      this.$api.Profile.getProfile().then(data => {
        let moduleIds = data.moduleIds
        const moduleIdsLen = moduleIds.length
        const REPLACE_MODULE_ID_MAP = process.env.REPLACE_MODULE_ID_MAP

        if (REPLACE_MODULE_ID_MAP) {
          for (let i = 0; i < moduleIdsLen; i++) {
            const newModuleId = REPLACE_MODULE_ID_MAP[moduleIds[i]]

            if (newModuleId) {
              moduleIds[i] = newModuleId
            }
          }
        }

        this.$store.commit('Profile/setAccountInfo', {
          ...data,
          permissions: moduleIds
        })

        this.addRoute(moduleIds)
      }).catch(error => {
        console.error(error)

        if (error.code === 408) {
          this.$store.commit('Profile/removeToken')
        }
      })
    },
    addRoute (moduleIds) {
      let route = getRouteByModuleIds(moduleIds)
      let router = this.$router

      this.$store.commit('Profile/setNavList', route.children)
      router.addRoute(route)

      if (/^\/(login)?$/.test(this.$route.path)) {
        router.replace(this.getFirstRoute(this.navList[0]))
      }
    },
    getFirstRoute (route) {
      for (let children = route.children; Array.isArray(children) && children.filter(route => route.isNav).length > 0;) {
        route = children[0]
        children = route.children
      }

      return route
    },
    err417 (message) {
      this.$notify({
        title: '错误',
        message,
        type: 'error',
        position: 'bottom-right'
      })
    },
    err444 (message) {
      this.$notify({
        title: '提示',
        message,
        type: 'warning',
        position: 'bottom-right'
      })
    },
    err408 (message) {
      this.$store.commit('Profile/removeToken')
    },
    err500 (message) {
      this.err417(message)
    },
    onResponseError (error) {
      let method = this[`err${error.code}`]
      method && method(error.message)
    },
    onWindowResize () {
      this.$eventBus.emit(EventKeyMap.WINDOW_RESIZE)
    }
  },
  watch: {
    userToken: {
      immediate: true,
      handler (newVal) {
        this.onRedirect(newVal)
      }
    }
  },
  created () {
    let systemName = process.env.SYSTEM_NAME
    document.title = systemName.cnName
    let eventBus = this.$eventBus
    eventBus.on(EventKeyMap.RESPONSE_ERROR, this.onResponseError)
    window.addEventListener('resize', this.onWindowResize, true)
  },
  beforeDestroy () {
    let eventBus = this.$eventBus
    eventBus.off(EventKeyMap.RESPONSE_ERROR, this.onResponseError)
    window.removeEventListener('resize', this.onWindowResize, true)
  }
}
</script>

<style lang="scss">
@import "@/assets/style/index.scss"
</style>



// WEBPACK FOOTER //
// src/App.vue